import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import numeral from 'numeral';
import Spinner from 'react-spinner-material';
import { BarLoader } from 'react-spinners';

import styled from 'styled-components';

import ActionButton from 'SharedComponents/action-button';
import ModalDialogV3 from 'SharedComponents/modal-dialog-v3';
import PopoverHover from 'SharedComponents/popover-hover';
import TextInput from 'SharedComponents/text-input';
import PaymentStripe from 'SharedComponents/payment-stripe';
import SelectSubscriptionPlan from 'SharedComponents/select-subscription';


import log from "Utils/logger";

import * as SubscriptionActions from 'Flux/subscriptions/actions';
import * as AuthenticationActions from 'Flux/authentication/actions';



import styles from './index.css';

// Define default format for numbers in numeral
numeral.defaultFormat('0,0.00');

// Set default format for nulls
numeral.nullFormat('0.00');
numeral.zeroFormat('0.00');


const PromoCodePurchaseButtonWrapper = styled.div`${styles}`;

//const TextInputWithFormsy = withFormsy(TextInput);

const PromoCodePurchaseButton = () => {


  const availableEmployerSubscriptionPlans = useSelector(state => 
    state.subscriptions.availSubscriptionPlans.filter(plan => plan.subscriptionSponsor === 'employer')
  );

  const selectedPlan = Array.isArray(availableEmployerSubscriptionPlans) 
  ? availableEmployerSubscriptionPlans.find(plan => typeof plan.subscriptionAmount === "number" && plan.subscriptionAmount > 0) 
  : null;

  console.log('PromoCodePurchaseButton triggered with availableEmployerSubscriptionPlans: ', availableEmployerSubscriptionPlans);
  //console.log('PromoCodePurchaseButton triggered with formattedOptions: ', formattedOptions);
  //console.log('PromoCodePurchaseButton triggered with selectedPlan: ', selectedPlan);
  //console.log('PromoCodePurchaseButton triggered with selectedPlanValue: ', selectedPlanValue);

  const [showModalDialogV3, setShowModalDialogV3] = useState(false);


  useEffect(() => {
    console.log('PromoCodePurchaseButton useEffect triggered with availableEmployerSubscriptionPlans: ', availableEmployerSubscriptionPlans);

    console.log('PromoCodePurchaseButton - mounted');
    return (() => {
      console.log('PromoCodePurchaseButton - unmounted');
    });
  }, []);




  return (
    <PromoCodePurchaseButtonWrapper>
      <div className="button-container">
        <ActionButton
          text="Purchase Employer Code"
          onClick={() =>  setShowModalDialogV3(true)}
          color="#fff"
          large={true}
          //disabled={!selectedPlan.subscriptionName.toLowerCase().includes("employer")}
        />
        <span className="pop-over-container">
          <PopoverHover
            content={
              <div style={{
                maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
              }}
              >
              Your Employer can choose to purchase a code for you to use here as part of their employer benefits package. Select an Employer Sponsored plan and then click to find out more.
              </div>
            }
            header = {null}
            img = {null}
            itemToPopover = {
              ( <i className="material-icons" style={{ margin: '0 5px 0 5px', fontSize: '34px' }} >info</i> )
            }
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
          />
        </span>
        <ModalDialogV3 
            open={showModalDialogV3}
            onCloseModalDialogV3={() => setShowModalDialogV3(false)}
            titleComponent={"Purchase Subscription Code for Employees"}
            titleComponentOverideStyles={{ fontSize: "26px", padding: "0px", textAlign: "center" }}
            explainerComponent={
              <div>
                <SelectSubscriptionPlan
                  subscriptionFeaturesOn={false}
                  sponsorFilter={"employer"}
                />
              </div>
            }
            explainerComponentOverideStyles={{ padding: "0px" }}
            contentComponent={
              <PaymentStripe
                 selectedPlan={selectedPlan}
            //    onPaymentSuccess={() => {
            //      setShowModalDialogV3(false);
            //      //onSuccess();
            //    }}
            //    onPaymentFailure={() => {
            //      setShowModalDialogV3(false);
                  //onError('Payment failed. Please try again.');
                  //setTimeout(() => {
                  //  onError('');
                  //}, 3000);
            //    }}
              />
            }
          /> 
      </div>
    </PromoCodePurchaseButtonWrapper>
  );
}

export default PromoCodePurchaseButton;